import React, { useState } from 'react';
import { FcSearch } from 'react-icons/fc';
import { IoCloseCircleSharp } from 'react-icons/io5';
import './InputCity.css';

const InputCity = ({ onInputChange, currentCity }) => {
    const [value, setvalue] = useState('');

    const onChange = (e) => {
        const newValue = e.target.value;
        setvalue(newValue);
        onInputChange(newValue);
    };

    const clearInput = () => {
        setvalue('');
        onInputChange('');
    }

    const containerSecondClass = currentCity ? '' : 'search__input-container--full';

    return (
        <div className={`search__input-container ${containerSecondClass}`}>
            <div className="search__input-icon"><FcSearch /></div>
            <input type="text" className="search__input" placeholder="Busca una ciudad" onChange={onChange} value={value} />
            {value !== '' && <div className="search__cancel-icon" onClick={clearInput} ><IoCloseCircleSharp /></div>}
        </div>  
    )
}

export default InputCity;
